import Styled from 'styled-components';

const backgroundColor = `#3880ff`;
const activeBackgroundColor = `#04AA6D`;
const menuColor = `#FFFFFF`;

const FlexSpaceBetween = Styled.div`
width: 100%;
z-index: 10000;
display: flex;
flexDirection: row;
justify-content: space-between;
overflow: hidden;
`;

const FlexRowDiv = Styled.div`
cursor: pointer;
display: flex;
flex-direction: row;
justify-content: flex-start;
align-items: center;
height: 60px;
padding-left: 16px;
padding-right: 16px;
color: ${menuColor};
&:hover {
  background-color: ${activeBackgroundColor};
  border: 1px solid lightgray;
}
`;

const DropdownMenu = Styled.div`
padding: 16px 20px;
cursor: pointer;
color: ${menuColor};
&:hover {
  background-color: ${activeBackgroundColor};
  border: 1px solid lightgray;
}
`;

const Dropdown = Styled.div`
&:hover {
  background-color: ${activeBackgroundColor};
}
`;

const DropdownContent = Styled.div`
  visibility: hidden;
  position: absolute;
  background-color: white;
`;

const MenuContainer = Styled.div`
border: 0px solid ${activeBackgroundColor};
margin-top: 0px;
background-color: ${backgroundColor};
padding: 6px;
`;

export { FlexSpaceBetween, FlexRowDiv, DropdownMenu, Dropdown, DropdownContent, MenuContainer }